import React from 'react'

import type { ReservationCalendarsResponse } from '../../../common/validations/reservationCalendarSchemas'
import { useAPIGetReservationCalendars } from '../../api/apiHooks/useAPIGetReservationCalendars'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'
import { UserMetadata } from '../../../common/validations'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

type ReservationCalendarForResident = ReservationCalendarsResponse[0]

interface ReservationCalendarsDataLoaderProps {
  reservableCategory?: string
  weekStartDate?: string
  refreshKey?: string | string[]
  children: (
    calendars: ReservationCalendarForResident[],
    isLoading: boolean,
    userMetadata: UserMetadata
  ) => React.ReactNode
}

export const ReservationCalendarsDataLoader: React.FC<
  ReservationCalendarsDataLoaderProps
> = ({ reservableCategory, weekStartDate, refreshKey, children }) => {
  const { currentContractId } = useCurrentContract()
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  const { data: calendars = [], isLoading } = useAPIGetReservationCalendars(
    currentContractId,
    reservableCategory,
    weekStartDate,
    refreshKey
  )

  return <>{children(calendars, isLoading, userMetadata)}</>
}
